<template>
  <div class="wrapper">
    <p v-if="profits.length<=0 && showLoading===false" class="center" style="margin-top:12px;font-size: 14px;">暂无记录</p>
    <SheetItem
      v-for="item in profits"
      v-else
      :key="item.profitId"
      :month="item.month"
      :company-name="item.companyName"
      :to="`/profit-detail/${item.profitId}`"/>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import SheetItem from '../../components/SheetItem';

  export default {
    name: "Profits",
    components: {
      SheetItem
    },
    computed: {
      ...mapGetters(['profits','showLoading'])
    },
    methods: {
      ...mapActions(['getProfits'])
    },
    created() {
      window.document.title = '利润表';
      this.getProfits();
    }
  }
</script>

<style scoped>

</style>